import ReactSelect from 'react-select'
import ReactAsyncSelect from 'react-select/async'
import ReactAsyncCreatableSelect from 'react-select/async-creatable'

const PREFIX = 'rsx'

export function Select(props) {
  return <ReactSelect {...props} classNamePrefix={PREFIX} />
}

export function AsyncSelect(props) {
  return <ReactAsyncSelect {...props} classNamePrefix={PREFIX} />
}

export function AsyncCreatableSelect(props) {
  return <ReactAsyncCreatableSelect {...props} classNamePrefix={PREFIX} />
}
